import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useLayout } from 'utils/hooks/useLayout';

export interface HeadingProps {
  heading?: string;
  headingLogo?: string;
  headingProps?: {
    back: string;
  };
  mobilePadding?: boolean;
  desktopOnly?: boolean;
  className?: string;
}

export const usePageHeading = (heading: string | HeadingProps, deps?: unknown[]) => {
  const layout = useLayout();
  const { t } = useTranslation();

  useLayoutEffect(() => {
    layout.resetHeading();
    if (typeof heading === 'string') {
      layout.setHeading(heading);
    } else if (typeof heading === 'object') {
      heading.heading && layout.setHeading(heading.heading);
      heading.headingLogo && layout.setHeadingLogo(heading.headingLogo);
      heading.headingProps && layout.setHeadingProps(heading.headingProps);
      heading.mobilePadding && layout.setMobilePadding(heading.mobilePadding);
      heading.desktopOnly && layout.setDesktopOnly(heading.desktopOnly);
      heading.className && layout.setClassName(heading.className);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps ?? [t]);
};

export default usePageHeading;
